import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnInit,
    Output,
    TemplateRef,
    ViewEncapsulation,
} from '@angular/core';
import { ObjectTypes } from '@fi-shared/types';
import { ISectionCardData } from '@fi-shared/fi-section-card/fi-section-card';
import { AppTextService } from '@fi-shared/app-text';
import { FiChecklist2ScheduleRolesEditorDialogComponent } from '@fi-shared/checklist/schedule/schedule-edit/roles-settings/roles-editor-dialog/roles-editor-dialog.component';
import { FiDialogsService } from '@fi-shared/fi-dialogs';
import { IAccessRightCoreFilter, IAccessRightFilterCollection } from '@fi-shared/models';
import { FiChecklist2ScheduleSharingDisplayService } from '@fi-shared/checklist/schedule/services/fi-checklist2-schedule-sharing-display.service';
import { ValidationErrors } from '@angular/forms';
import { FiComponentsContainer } from '@fi-shared/fi-components-container';
import { SaveChangesWarningService } from '@fi-shared/fi-shared-services/save-changes-warning.service';

@Component({
    selector: 'fi-checklist2-schedule-edit-roles-settings',
    templateUrl: './roles-settings.component.html',
    styleUrls: ['./roles-settings.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-checklist2-schedule-edit-roles-settings' },
    providers: [{ provide: FiComponentsContainer, useExisting: FiChecklist2ScheduleEditRolesSettingsComponent }],
    standalone: false,
})
export class FiChecklist2ScheduleEditRolesSettingsComponent extends FiComponentsContainer implements OnInit {
    @Input({ required: true }) accessRightCoreFilter: IAccessRightCoreFilter;
    @Output() accessRightCoreFilterChange = new EventEmitter<IAccessRightCoreFilter>();

    @Input() isOperationalSchedule: boolean;
    @Input() availableAccessRightFilterCollection: IAccessRightFilterCollection;
    @Input() scheduleSettingsSharingInfoContainer: TemplateRef<any>;
    @Input() scrollableElementRefs: ElementRef[];
    roleAccessContentCardData: ISectionCardData;

    readonly ObjectTypes = ObjectTypes;

    constructor(
        private appTextService: AppTextService,
        private fiDialogsService: FiDialogsService,
        private cdr: ChangeDetectorRef,
        private fiChecklist2ScheduleSharingDisplayService: FiChecklist2ScheduleSharingDisplayService,
        private saveChangesWarningService: SaveChangesWarningService,
    ) {
        super();
    }

    ngOnInit() {
        this.setContentCardsData();
    }

    private setContentCardsData() {
        this.roleAccessContentCardData = {
            headerTextLabel: this.appTextService.get('checklist.checklist_access'),
            subheaderTextLabel: this.appTextService.get('checklist.checklist_access_description'),
            id: undefined,
        };
    }

    editChecklistRoleSharing() {
        this.fiDialogsService
            .custom({
                contentComponentRef: FiChecklist2ScheduleRolesEditorDialogComponent,
                contentComponentData: {
                    availableRoles: this.availableAccessRightFilterCollection.AccessRightCoreFilter.Roles,
                    checklistScheduleAccessRightCoreFilter: this.accessRightCoreFilter,
                },
                hideDialogTopBorder: true,
                headerText: this.appTextService.get('checklist.checklist_access'),
                yesButtonText: this.appTextService.get('done'),
                preventUppercaseButtonLabel: true,
                config: {
                    closeOnNavigation: false,
                    autoFocus: false,
                    panelClass: ['fi-rounded-dialog-panel', 'fi-rounded-dialog-full-round-buttons'],
                },
            })
            .onYesButtonClick((selectedRoleIds) => {
                this.accessRightCoreFilter.RoleIds = selectedRoleIds;
                //this.changeBusinessAreaSelection();
                this.onScheduleAccessRightCoreFilterChange();
                this.cdr.markForCheck();
            })
            .afterClosed(() => (this.saveChangesWarningService.closeDialogOnTransition = false));

        this.saveChangesWarningService.closeDialogOnTransition = true;
    }

    /*private changeBusinessAreaSelection() {
        if (this.availableAccessRightFilterCollection.AccessRightCoreFilter.BusinessAreas.length === 1) {
            this.accessRightCoreFilter.BusinessAreaIds = this.accessRightCoreFilter.RoleIds ?
                [this.availableAccessRightFilterCollection.AccessRightCoreFilter.BusinessAreaIds[0]] : [];
        }
    }*/

    getSelectedRolesNames(): string {
        return this.fiChecklist2ScheduleSharingDisplayService.getSelectedSharingItemsNamesByObjectType(
            ObjectTypes.Role,
            this.accessRightCoreFilter,
            this.availableAccessRightFilterCollection.AccessRightCoreFilter,
        );
    }

    onScheduleAccessRightCoreFilterChange() {
        this.accessRightCoreFilterChange.emit(this.accessRightCoreFilter);
    }

    validateRoleSettingsFn = (): ValidationErrors => {
        return {
            'no-role-selected': this.isOperationalSchedule && !this.accessRightCoreFilter.RoleIds.length,
        };
    };
}
